import React from "react";
import { observer } from "mobx-react";
import Box from "@mui/material/Box";
import HeaderContainer from "@ui/features/Header/Header.container";
import withPage from "@ui/HOCs/withPage";
import withSideBar from "@ui/HOCs/withSideBar";
import withSection from "@ui/HOCs/withSection";
import withSections from "@ui/HOCs/withSections";
import { lang } from "@lang/interfaces/lang";
import GeozoneListSidebar from "../features/Geozones/Geozone-list/Geozone-list";
import { GeozoneMap } from "../features/Geozones/Geozone-map/Geozone-map";

interface IProps extends JSX.IntrinsicAttributes {
    lang: lang;
}

const SideBar = withSideBar(GeozoneListSidebar);
const Map = withSection(GeozoneMap);
const SectionsContent: React.FC<IProps> = () => {
    return (
        <>
            <Map />
        </>
    );
};
const Sections = withSections(SectionsContent);

const Page: React.FC<IProps> = ({ lang }: IProps) => {
    return (
        <>
            <HeaderContainer />
            <Box className="main" component="main">
                <Box width="415px" padding="1rem 1rem 0 1rem">
                    <GeozoneListSidebar />
                </Box>
                <Sections lang={lang} />
            </Box>
        </>
    );
};

const WrappedPage = withPage(Page, "main__wrap", "locationHistory");

const GeozonesPage = observer(WrappedPage);

export default GeozonesPage;
